import type { PortfolioDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { PortfolioProductCard } from './portfolio-product-card';

interface PortfolioProductsProps {
  readonly products: PortfolioDetail['products'];
  readonly onRetry: () => void;
}

export const PortfolioProducts = ({ products, onRetry }: PortfolioProductsProps): ReactElement => {
  if (products.length === 0)
    return <p className="text-sm text-muted-foreground">연결된 상품이 없습니다.</p>;
  return (
    <section aria-labelledby="portfolio-products">
      <h2
        id="portfolio-products"
        className="border-b border-foreground pb-4 text-2xl leading-tight font-bold tracking-[-0.02em]"
      >
        포함 상품
      </h2>
      <div className="mt-8 grid grid-cols-2 gap-x-4 gap-y-10 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4">
        {products.map((product) => (
          <PortfolioProductCard key={product.id} product={product} onRetry={onRetry} />
        ))}
      </div>
    </section>
  );
};
